import { ProviderItemInputs } from './provider-item-inputs';
export class CartItem {
    public amount: string;
    public commission: number;
    public currency: string;
    public paymentProviderGUID: string;
    public paymentProviderInputs: ProviderItemInputs[];

    constructor(amount: string, commission: number, currency: string, paymentProviderGUID: string, paymentProviderInputs: ProviderItemInputs[]) {
        this.amount = amount;
        this.commission = commission;
        this.currency = currency;
        this.paymentProviderGUID = paymentProviderGUID;
        this.paymentProviderInputs = paymentProviderInputs;
    }
}